/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.blockModule')
  .constant('DRAG', {
    TOUCH_DELAY: 1000,
    END_EVENT_DRAG_KILL_WAIT: 200, // Time in ms to wait until all end events have fired before stopping the drag
  // operation. Stopping the drag too soon would mean subsequent end events trigger the equivalent of a mouse click.
  })
// Add the constants to the root scope:
  .run(['$rootScope', 'DRAG', function ($rootScope, DRAG) {
    $rootScope.DRAG = DRAG;
  }]).directive('bulbDraggableUnitBlockContainer', [
    '$timeout',
    'BulbAuthService',
    'BulbBlockViewSwitcherService',
    'BulbSubCollectionService',
    'BulbUnitDroppableService',
    'BulbBrowserService',
    'DRAG',
    bulbDraggableUnitBlockContainer,
  ]);

function bulbDraggableUnitBlockContainer(
  $timeout,
  BulbAuthService,
  BulbBlockViewSwitcherService,
  BulbSubCollectionService,
  BulbUnitDroppableService,
  BulbBrowserService,
  DRAG,
) {
  return {
    restrict: 'E',
    scope: {
      compositeUnit: '=',
      infoType: '@',
    },
    templateUrl: 'ajs/components/block/draggableunitblockcontainer.html',
    controller: 'DraggableUnitBlockContainerController as draggableUnitBlockContainerCtrl',
    bindToController: true,
    link(scope, element, attrs, draggableUnitBlockContainerCtrl) {
      // Only enable for iOS right now. It doesn't work for tablets or Android.
      scope.isMobile = BulbBrowserService.isMobile();

      const { compositeUnit } = draggableUnitBlockContainerCtrl;

      // Prevents tab/select the container, because outlining or selecting it would be
      // weird.
      element.find('.bulb-sortable-block-container').removeAttr('tabindex');
      // Type of info being passed down to the directive.
      draggableUnitBlockContainerCtrl.infoType = attrs.infoType;

      BulbBlockViewSwitcherService.disableDraggingForArchiveCollection();

      // Function Handler for touch and hold to drag, used on mobile devices only.
      const longPressHoldToDragOnMobile = function longPressHoldToDragOnMobile() {
        // Variable to keep track of if we're in the middle of a mobile drag operation by the user.
        let isMobileDragging = false;
        // Original Y location of where the user started a touch event.
        let originalTouchY = null;
        // Hold the promise for the touch hold timeout so we can cancel it if needed.
        let touchHoldTimeout = null;
        // Longpress on Android needs to save off the last start event.
        let lastTouchStartInfo = null;

        // Scope variable to enable "data-drag" in the html which makes it moveable via the angular-dragdrop lib
        scope.mobileTouchHoldReached = false;

        // Drag must have ended, set the vars back that are needed for dragging.
        const clearPressHoldDragOnElement = function clearPressHoldDragOnElement(node, message) { // Log message param for troubleshooting.
          isMobileDragging = false;
          scope.mobileTouchHoldReached = false;
          jQuery(node).draggable().draggable('disable');
        };

        // Clear the timer that starts when the user presses, and enables drag after 1s.
        const clearDragStartTimer = function clearDragStartTimer(message) { // log message param for troubleshooting.
          if (touchHoldTimeout !== null) {
            $timeout.cancel(touchHoldTimeout);
            touchHoldTimeout = null;
          }
          originalTouchY = null;
        };

        const bulbMobileDragEventHandlers = (function () {
          // Called when we're ready to start the drag operation on the node param.
          const startDraggingNode = function startDraggingNode(event, node) {
            isMobileDragging = true;

            clearDragStartTimer('Drag started, 1 second threshold reached');

            // This sets the angular-dragdrop library's data-drag to true so  the drag flow handles well.
            scope.mobileTouchHoldReached = true;

            /* We need to manually call into jquery draggable. because the scope call doesn't do
                           it on its own, it only helps the angular-dragdrop library along. */
            /**
             * Both calls to draggable() are required here because draggable must be initialized on the node
             * Before we can call any methods on it. This is required for the fix for BULBAPP-5910
             */
            jQuery(node).draggable().draggable('enable');

            /*  The mouse or touch event must be re-triggered on the element after
                            we enable draggable if we want to start dragging without the user
                            having to click again. */
            // https://stackoverflow.com/questions/8759884/jquery-how-to-fire-the-drag-event-while-mouse-is-still-down
            jQuery(node).trigger(event);

            /*  This class is added manually so that the dragging element lights up  blue right
                            away instead of waiting until the user moves it further. This class is managed
                            by the Jquery Draggable library, and is normally added and removed
                            automatically. We use it for stylying purposes. */
            jQuery(node).addClass('ui-draggable-dragging');
          };

          // Android drag handling for OS, the long press android menu makes things difficult.
          const startDraggingOnAndroidMenu = function startDraggingOnAndroidMenu() { // Requires saving off the last node and event.
            startDraggingNode(lastTouchStartInfo.event, lastTouchStartInfo.node);
          };

          const dragStartCallback = startDraggingOnAndroidMenu.bind(this);
          BulbBrowserService.androidBlockAndExecuteCallbackOnOptionsMenu(dragStartCallback);

          return {

            // Handle a move (or drag) event
            handleMoveEvents() {
              clearDragStartTimer('Cleared drag-drop timer from move.');
            },

            // Handle the end of the drag
            handleEndEvents(event, node) {
              $timeout(() => {
                clearPressHoldDragOnElement(node, 'Non-move event cleared drag-drop ability.');
              }, DRAG.END_EVENT_DRAG_KILL_WAIT);

              clearDragStartTimer('touch-out cleared drag-drop ability.');
            },

            // Handle the start of the drag
            handleStartEvents(event, node) {
              // Prevent the 3D touch and hard press "preview page" dialog on newer iOS Devices.
              if (BulbBrowserService.isIOSMobile() && touchHoldTimeout !== null) {
                event.preventDefault();
              }

              // Used on Android only. See options menu code above.
              lastTouchStartInfo = ({ event, node });

              if (isMobileDragging) {
                return;
              }

              // Start a timeout to wait the touch-hold time to start the drag.
              touchHoldTimeout = $timeout(() => {
                startDraggingNode(event, node);
              }, DRAG.TOUCH_DELAY);
            },
          };
        }());

        $timeout(() => { // Needed because we need the DOM to be completely loaded first.
          // Attach event handlers to each article.
          element.find('article').each((index, article) => {
            jQuery(article).on('touchend mouseup mouseleave', (event) => { // End-touch functions. touchend
              // mouseup mouseleave
              bulbMobileDragEventHandlers.handleEndEvents(event, article);
            }).on('touchstart', (event) => { // touchstart mousedown
              bulbMobileDragEventHandlers.handleStartEvents(event, article);
            }).on('mousemove', (event) => { // Touchmove events. mousemove
              bulbMobileDragEventHandlers.handleMoveEvents(event);
            });
          });
        });
      };

      // Enable draggable if not mobile, enable long-press otherwise. called on ng-init so that it will
      // re-evaluate when the viewSwitcher service converts from list view to block view.
      scope.evaluateMobile = function evaluateMobile() {
        if (scope.isMobile) {
          longPressHoldToDragOnMobile();
        }
      };

      // Callback functions for various drag operations called from draggableunitblockcontainer.html
      // and courtesy of angular-dragdrop.js
      scope.dragAndDrop = (function dragAndDrop() {
        const reorderChildren = function (newIndex, selectedUnit) {
          const { children } = compositeUnit;
          children.forEach((childUnit, index) => {
            if (childUnit === selectedUnit) {
              children.splice(index, 1);
            }
          });
          children.splice(newIndex, 0, selectedUnit);
          return draggableUnitBlockContainerCtrl.saveReorder(newIndex);
        };

        return {

          /*
            The callbacks below are hooked up in draggableunitblockcontainer.html
            and are courtesy of the angular-dragdrop.js library. This lib is built on
            top of Jquery draggable. These libraries are not tailored for mobile touch hold drag.
            The DragDropTouch.js lib helps with mobile by converting mobile touch events
            into the appropriate mouse events. We are also using "Touch Punch" for mobile help.
            DragDropTouch.js however, has its limitations as there isn't a perfect 1 to 1
            between mouse and touch functionality.
           */

          onDragStart(event, ui, index, dragUnit) {
            if (dragUnit.unitType === 'CompositeUnit'
              && (!BulbAuthService.currentUser.features.SubCollectionFeature.enabled
                || !BulbSubCollectionService.canDropCollectionIntoSubCollection())) {
              // Disable dropping collections on collections if the user doesn't have the feature:
              jQuery('.bulb-block-wrapper.bulb-block-collection').droppable('disable');
            }

            // Adding bulb-dragging (pointer-events: none) is required because desktop browsers will
            // Add a click event when you let go of the item unless this class is added while dragging
            // The added click event navigates to the recently dragged tile.
            ui.helper.addClass('bulb-dragging');
            jQuery(`#drop-order-${index}, #drop-order-${index + 1}`).droppable('disable');

            // Safari on ipad doesn't always redraw css, the trick below helps.
            // https://stackoverflow.com/questions/10930010/jquery-style-not-being-applied-in-safari
            jQuery('body').addClass('dummyClass').removeClass('dummyClass');
          },

          onDragStop(event, ui, index) {
            // Re-enable dropping on collections for the next drag/drop operation:
            jQuery('.bulb-block-wrapper.bulb-block-collection').droppable('enable');

            ui.helper.removeClass('bulb-dragging');

            jQuery(`#drop-order-${index}, #drop-order-${index + 1}`).droppable('enable');
          },

          onOrderDrop(event, ui, index) {
            ui.draggable.removeAttr('style');
            reorderChildren(index > ui.draggable.scope().$index ? index - 1 : index, ui.draggable.scope().childUnit);
          },

          onEntryDrop(event, ui, index, dropTargetUnit) {
            BulbUnitDroppableService
              .onUnitDroppable(compositeUnit.children, ui.draggable.scope().childUnit, dropTargetUnit);
          },
        };
      }());
    },
  };
}
